import React from "react";
import PropTypes from "prop-types";
import {
  AddItemContainerStyled,
  LinkAddItemStyled,
  FloatAddItem,
  EndMessage,
  ButtonMore,
  ContainerButton,
  ButtonTop,
  IconButtonTop,
  FloatCustomAction,
  EmptyState,
  EmptyIcon,
  EmptyMessage,
} from "./InfiniteList.styled";
import InfiniteScroll from "react-infinite-scroll-component";
import { SwipeableList, Type as ListType } from "react-swipeable-list";
import "react-swipeable-list/dist/styles.css";

const InfiniteListView = (props) => {
  const {
    data,
    getMoreData,
    hasMore,
    renderItem,
    title,
    formlinkToAdd,
    iconAdd,
    classNameLinkAdd,
    tbLoadingText,
    tbNoDataText,
    variantTitle,
    floatButton,
    variantIcon,
    endMessage,
    messageButtonMore,
    id,
    customClassName,
    variantButtonMore,
    headerComponentList,
    renderLoader,
    loading,
    renderNewItemInList,
    addNewItemInList,
    customActionAdd,
    customAction,
    scrollableTarget,
    iconEmptyList,
  } = props;

  const gotoTop = () => {
    const element = document.querySelector(`#${id}_infiniteList`);
    if (element) {
      document.body.scrollTop = element.scrollTop; // For Safari
      document.documentElement.scrollTop = element.scrollTop;
    }
  };

  const defaultRenderNewItemInList = (i) => {
    return <div>{i.uuid}</div>;
  };

  return (
    <>
      <div id={`${id}_infiniteList`} className="row">
        <div className="col-10">
          {title ? <h5 $variant={variantTitle}>{title}</h5> : ""}
        </div>
        {customActionAdd ? (
          <FloatCustomAction
            onClick={() => customAction()}
            className={classNameLinkAdd || ""}
          >
            <i className={iconAdd || "fas fa-plus-square"} />
          </FloatCustomAction>
        ) : (
          <>
            {formlinkToAdd ? (
              <>
                {floatButton ? (
                  <FloatAddItem
                    to={formlinkToAdd}
                    type="routerDom"
                    $variant={variantIcon || "primary"}
                    className={classNameLinkAdd || ""}
                  >
                    <i className={iconAdd || "fas fa-plus-square"} />
                  </FloatAddItem>
                ) : (
                  <AddItemContainerStyled className="col-2">
                    <LinkAddItemStyled
                      to={formlinkToAdd}
                      type="routerDom"
                      $variant={variantIcon || "primary"}
                      className={classNameLinkAdd || ""}
                    >
                      <i className={iconAdd || "fas fa-plus-square"} />
                    </LinkAddItemStyled>
                  </AddItemContainerStyled>
                )}
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
      {loading && renderLoader ? (
        renderLoader()
      ) : (
        <>
          {headerComponentList && data && data.length > 0 && (
            <div className="row">
              <div className="col-12">{headerComponentList()}</div>
            </div>
          )}
          <div className="row">
            <div className="col-12">
              {data && data.length > 0 ? (
                <>
                  <InfiniteScroll
                    dataLength={data?.length || 0}
                    next={getMoreData}
                    loader={<h4>{tbLoadingText}</h4>}
                    hasMore={hasMore}
                    className={customClassName}
                    scrollableTarget={scrollableTarget}
                    endMessage={
                      endMessage ? (
                        <EndMessage className="infiniteList_customEndMessage">
                          <ButtonTop
                            $variant={variantButtonMore || "primary"}
                            type="button"
                            onClick={() => gotoTop()}
                          >
                            {endMessage || ""}
                            <IconButtonTop className="fas fa-chevron-up"></IconButtonTop>
                          </ButtonTop>
                        </EndMessage>
                      ) : undefined
                    }
                  >
                    <SwipeableList fullSwipe={false} type={ListType.IOS}>
                      {data.map((i) => {
                        if (
                          addNewItemInList &&
                          i?.uuid &&
                          i.uuid === "NEW-ITEM"
                        ) {
                          return renderNewItemInList
                            ? renderNewItemInList(i)
                            : defaultRenderNewItemInList(i);
                        }

                        return renderItem(i);
                      })}
                    </SwipeableList>
                  </InfiniteScroll>
                  {hasMore && (
                    <ContainerButton>
                      <ButtonMore
                        $variant={variantButtonMore || "primary"}
                        type="button"
                        onClick={() => getMoreData()}
                      >
                        {messageButtonMore || "Read more ..."}
                      </ButtonMore>
                    </ContainerButton>
                  )}
                </>
              ) : (
                <EmptyState>
                  <EmptyIcon>
                    <i className={iconEmptyList}></i>
                  </EmptyIcon>
                  <EmptyMessage>{tbNoDataText}</EmptyMessage>
                </EmptyState>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

InfiniteListView.propTypes = {
  data: PropTypes.array,
  getMoreData: PropTypes.func,
  hasMore: PropTypes.bool,
  renderItem: PropTypes.func,
  title: PropTypes.string,
  formlinkToAdd: PropTypes.string,
  iconAdd: PropTypes.string,
  classNameLinkAdd: PropTypes.string,
  tbLoadingText: PropTypes.string,
  tbNoDataText: PropTypes.string,
  variantTitle: PropTypes.string,
  floatButton: PropTypes.bool,
  variantIcon: PropTypes.string,
  endMessage: PropTypes.string,
  messageButtonMore: PropTypes.string,
  id: PropTypes.string,
  customClassName: PropTypes.string,
  variantButtonMore: PropTypes.string,
  headerComponentList: PropTypes.any,
  renderLoader: PropTypes.func,
  loading: PropTypes.bool,
  addNewItemInList: PropTypes.bool,
  renderNewItemInList: PropTypes.func,
  scrollableTarget: PropTypes.string,
};

export default InfiniteListView;
